module.exports = __webpack_public_path__ + "img/mnx.ed3d209c.svg";